module.exports = __webpack_public_path__ + "img/bannerbg_mobile.6ec7479e.jpg";